// Componente de skeleton para la vista de CRM - Skeleton component for CRM view
// Muestra placeholders que respetan la estructura de los bloques de la página (estética Orders/ViewOrders)
import { SectionBox } from '@shared/components/ui/SectionBox';
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const ViewCRMSkeleton = () => {
  return (
    <div className="py-4 px-6">
      <div className="flex flex-col md:flex-row justify-between items-start gap-6">
        {/* Columna Izquierda - Left Column */}
        <div className="w-full md:w-[70%] flex flex-col gap-5">
          {/* OrderInfo Skeleton - Skeleton de información del pedido */}
          <SectionBox className="bg-card-bg">
            <Skeleton className="h-6 w-48 rounded-full mb-4 bg-hover-press" />
            <div className="space-y-4 pt-4">
              <div className="flex items-center gap-4">
                <Skeleton className="h-10 w-10 rounded-full bg-hover-press" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-40 rounded-full bg-hover-press" />
                </div>
              </div>
              <div className="border-t border-card-border" />
              <div className="flex items-center gap-4">
                <Skeleton className="h-10 w-10 rounded-full bg-hover-press" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-36 rounded-full bg-hover-press" />
                </div>
              </div>
            </div>
          </SectionBox>

          {/* SelectedItems Skeleton - Skeleton de items seleccionados */}
          <SectionBox className="bg-card-bg">
            <div className="flex justify-between items-center mb-4">
              <Skeleton className="h-6 w-40 rounded-full bg-hover-press" />
              <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
            </div>
            <div className="space-y-4 pt-4">
              <div className="hidden md:grid md:grid-cols-12 gap-4 pb-2 border-b border-card-border">
                <Skeleton className="h-4 w-32 rounded-full col-span-6 bg-hover-press" />
                <Skeleton className="h-4 w-24 rounded-full col-span-3 bg-hover-press" />
                <Skeleton className="h-4 w-20 rounded-full col-span-2 bg-hover-press" />
                <Skeleton className="h-4 w-4 rounded-full col-span-1 bg-hover-press" />
              </div>
              <div className="space-y-4">
                {[1, 2, 3].map((item) => (
                  <div key={item} className="border-b border-card-border py-2">
                    <div className="hidden md:grid md:grid-cols-12 gap-4 items-center py-2">
                      <div className="col-span-6">
                        <div className="flex items-center gap-3">
                          <Skeleton className="h-12 w-12 rounded-md bg-hover-press" />
                          <div className="flex-1 space-y-2">
                            <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                            <Skeleton className="h-3 w-24 rounded-full bg-hover-press" />
                          </div>
                        </div>
                      </div>
                      <div className="col-span-3">
                        <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
                      </div>
                      <div className="col-span-2">
                        <Skeleton className="h-4 w-12 rounded-full bg-hover-press" />
                      </div>
                      <div className="col-span-1" />
                    </div>
                    <div className="md:hidden space-y-3">
                      <div className="flex items-center gap-3">
                        <Skeleton className="h-12 w-12 rounded-md bg-hover-press" />
                        <div className="flex-1 space-y-2">
                          <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                          <Skeleton className="h-3 w-24 rounded-full bg-hover-press" />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="space-y-3 pt-2 border-t border-card-border">
                <div className="flex justify-between items-center pt-3">
                  <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                </div>
                <div className="flex justify-between items-center pt-2 border-t border-card-border">
                  <Skeleton className="h-5 w-16 rounded-full bg-hover-press" />
                  <Skeleton className="h-5 w-28 rounded-full bg-hover-press" />
                </div>
              </div>
            </div>
          </SectionBox>
        </div>

        {/* Columna Derecha - Right Column */}
        <div className="w-full md:w-[30%] flex flex-col gap-5">
          {/* CRM Status/Tags/Notes Skeleton */}
          <SectionBox className="bg-card-bg">
            <Skeleton className="h-6 w-24 rounded-full mb-4 bg-hover-press" />
            <div className="space-y-4 pt-4">
              <Skeleton className="h-9 w-full rounded-full bg-hover-press" />
              <div className="flex gap-2">
                <Skeleton className="h-8 flex-1 rounded-md bg-hover-press" />
                <Skeleton className="h-8 flex-1 rounded-md bg-hover-press" />
              </div>
            </div>
            <div className="border-t border-card-border my-4" />
            <Skeleton className="h-6 w-20 rounded-full mb-4 bg-hover-press" />
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-6 w-16 rounded-full bg-hover-press" />
              <Skeleton className="h-6 w-20 rounded-full bg-hover-press" />
              <Skeleton className="h-6 w-12 rounded-full bg-hover-press" />
            </div>
            <div className="border-t border-card-border my-4" />
            <Skeleton className="h-6 w-16 rounded-full mb-4 bg-hover-press" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
              <Skeleton className="h-4 w-4/5 rounded-full bg-hover-press" />
            </div>
          </SectionBox>

          {/* Tracking / ShippingInfo Skeleton */}
          <SectionBox className="bg-card-bg">
            <div className="flex justify-between items-center mb-4">
              <Skeleton className="h-6 w-36 rounded-full bg-hover-press" />
              <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
            </div>
            <div className="pt-6 flex flex-col gap-6">
              <div>
                <Skeleton className="h-5 w-24 rounded-full mb-3 bg-hover-press" />
                <div className="flex flex-col gap-3">
                  <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-3/4 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-2/3 rounded-full bg-hover-press" />
                </div>
              </div>
              <div className="border-t border-card-border" />
              <div>
                <Skeleton className="h-5 w-28 rounded-full mb-3 bg-hover-press" />
                <div className="flex flex-col gap-3">
                  <Skeleton className="h-4 w-full rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-5/6 rounded-full bg-hover-press" />
                </div>
              </div>
            </div>
          </SectionBox>

          {/* AdditionalInfo Skeleton */}
          <SectionBox className="bg-card-bg">
            <div className="flex justify-between items-center mb-4">
              <Skeleton className="h-6 w-40 rounded-full bg-hover-press" />
              <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
            </div>
            <div className="space-y-4 pt-4">
              <div className="flex items-center gap-4">
                <Skeleton className="h-10 w-10 rounded-full bg-hover-press" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                  <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                </div>
              </div>
            </div>
          </SectionBox>
        </div>
      </div>
    </div>
  );
};
